// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CheckoutSlider_wrapper__3nDrR","preview":"CheckoutSlider_preview__jjZaY"};